import type { StoreScale } from "./types";

/** 门店规模 Tag 颜色 */
export const getStoreScaleColor = (scale: string): string => {
  if (scale === "大型") return "blue";
  if (scale === "中型") return "green";
  return "gold";
};

/** 规模展示主题（详情卡片渐变） */
export const STORE_SCALE_THEME: Record<StoreScale, { tagColor: string; gradient: string }> = {
  大型: {
    tagColor: "red",
    gradient: "bg-linear-to-br from-red-400 via-red-500 to-orange-500",
  },
  中型: {
    tagColor: "gold",
    gradient: "bg-linear-to-br from-amber-400 via-amber-500 to-orange-500",
  },
  小型: {
    tagColor: "green",
    gradient: "bg-linear-to-br from-emerald-400 via-emerald-500 to-teal-500",
  },
};
